import React, { useEffect, useRef, useState } from 'react'
import './player-selector.styles.scss';
import SearchBar from '../search-bar/search-bar.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faBarcode, faFilter, faList, faUsers } from '@fortawesome/free-solid-svg-icons';
import CategoryFilterModal from '@/components/MANAGE-GAME/create-elements/components/category-filter-modal.component';
import { useLocation, useSearchParams } from 'react-router-dom';
import ImageContainer from '../image-container/image-container.component';
import { sortPlayers } from '@/utils/sortPlayers';
import { useSelector } from 'react-redux';
import { faCheckSquare } from '@fortawesome/free-regular-svg-icons';
import Modal, { ModalAlert } from '@/components/modal/modal.component';
import QrCodeScanner from '@/components/MANAGE-GAME/qr-code-scanner/qr-code-scanner.component';
import QRCodeScannerV2 from '@/components/MANAGE-GAME/qr-code-scanner/qr-code-scanner-v2.component';

const PlayerSelector = ({ 
    playerList, 
    teamMembers,
    chosenPlayers, 
    togglePlayer, 
    type // "player" or "team"
}) => {

    const screenSize = useSelector(state => state.contentData.screenSize);
    const membership = useSelector(state => state.userData.membership);
    const [ playersToDisplay, setPlayersToDisplay ] = useState([]);
    const [ teams, setTeams ] = useState([]);
    const [ showFilterModal, setShowFilterModal ] = useState(false);
    const [ showInfoFilterModal, setShowInfoFilterModal ] = useState(false);
    const [ chosenTeams, setChosenTeams ] = useState([]);
    const [ infoList, setInfoList ] = useState([]);
    const [ chosenInfo, setChosenInfo ] = useState([]);
    const [ showQRModal, setShowQRModal ] = useState(false);
    const [ alertMessage, setAlertMessage ] = useState(null);
    const playerRef = useRef();
    const chosenTeamsRef = useRef();
    const chosenInfoRef = useRef();
    const teamsRef = useRef();
    const location = useLocation();

    const [ searchParams ] = useSearchParams();
    const [ selectedPlayerPath, setSelectedPlayerPath ] = useState(searchParams.get("p"));

    useEffect(() => {
        if (!playerList || !type) return;
        search();
        setTeams(Object.values(playerList).filter(t => t.team))
        setInfoList(
            [...new Set(Object.values(playerList)
                .filter(p => p.info)
                .map(p => p.info))
            ]
        )
    }, [playerList, type, teamMembers])

    useEffect(() => {
        search();
    }, [chosenTeams, chosenInfo])

    useEffect(() => {
        if (!playerList || !selectedPlayerPath) {return;}
        const player = Object.values(playerList)
        .find(p => p.path === selectedPlayerPath);
        if (!player) {return;}
        if (chosenPlayers.includes(player.playerId)) {
            setAlertMessage(`Player ${player.displayName} is already selected.`);
            return;
        }
        togglePlayer(player, 'select');
        setAlertMessage(`Selected player: ${player.displayName}`);
    }, [playerList, selectedPlayerPath])

    function selectAll() {
        for (let p of playersToDisplay) {
            togglePlayer(p, 'select')
        }
    }
 
    function deselectAll() {
        for (let p of playersToDisplay) {
            togglePlayer(p, 'deselect')
        }
    }

    function search() {
        let text = document.getElementById('player-search-input').value;
        let filteredList = [];
        if (chosenTeams.length > 0) {
            for (let teamId of chosenTeams) {
                const team = playerList[teamId];
                if (!team.opt_members) continue;
                for (let playerId of team.opt_members) {
                    if (!playerList[playerId]) continue;
                    filteredList.push(playerList[playerId])
                }
            }
        } else {
            filteredList = Object.values(playerList);
        }
        if (chosenInfo.length > 0) {
            filteredList = filteredList
            .filter(p => chosenInfo.includes(p.info))
        }
        const sortedFilteredPlayers = sortPlayers({
            'playerList': filteredList,
            'filter': type
        })
        if (!text) {
            setPlayersToDisplay([...sortedFilteredPlayers]);
            return;
        }
        const searchedPlayers = sortedFilteredPlayers
        .filter(t => (
            t.fName.toLowerCase().includes(text.toLowerCase()) || 
            (t.lName && t.lName.toLowerCase().includes(text.toLowerCase())) || 
            t.displayName.toLowerCase().includes(text.toLowerCase())
        ))
        setPlayersToDisplay([...searchedPlayers]);
    }

    function chooseTeam(id) {
        if (!chosenTeamsRef.current) chosenTeamsRef.current = [];
        const tempTeams = [...chosenTeamsRef.current];
        if (tempTeams.includes(id)) {
            tempTeams.splice(tempTeams.indexOf(id), 1)
        } else {
            tempTeams.push(id);
        }
        chosenTeamsRef.current = [...tempTeams];
        setChosenTeams(chosenTeamsRef.current);

    }

    function chooseInfo(id) {
        if (!chosenInfoRef.current) chosenInfoRef.current = [];
        const tempInfo = [...chosenInfoRef.current];
        if (tempInfo.includes(id)) {
            tempInfo.splice(tempInfo.indexOf(id), 1)
        } else {
            tempInfo.push(id);
        }
        chosenInfoRef.current = [...tempInfo];
        setChosenInfo(chosenInfoRef.current);
    }

    function scanPlayerQRCode(playerPath) {
        setSelectedPlayerPath(playerPath);
        
    }

    return (
        <div className='player-selector'>
            
            <div className={`search-row ${screenSize}`}>
                
                <div className='player-search-input'>
                <SearchBar 
                    search={search} 
                    idLabel="player-search-input" />
                    {
                        (screenSize === 'mobile' ||
                        screenSize === 'tablet') &&
                        <div className='buttons'>
                            <button 
                                className='g-button med-btn'
                                onClick={() => setShowQRModal(true)}>
                                <FontAwesomeIcon icon={faBarcode} />
                            </button>
                        </div>
                    }
                </div>
                {
                    (!location.pathname.includes('/teams/') && type !== 'teams') &&
                    <button 
                        className={`g-button filter-button ${
                            screenSize === 'mobile' ? 'small-btn' : 'med-btn'
                        }`} onClick={() => setShowFilterModal(true)}>
                        <FontAwesomeIcon 
                            icon={faFilter} 
                            className={
                                chosenTeams.length > 0 
                                ? 'full' 
                                : 'empty'
                            } />
                        {
                            screenSize === 'mobile'
                            ? <FontAwesomeIcon icon={faUsers} />
                            : 'Teams'
                        }
                    </button>
                }
                {
                    (type !== 'teams') &&
                    <button 
                        className={`g-button filter-button ${
                            screenSize === 'mobile' ? 'small-btn' : 'med-btn'
                        }`} 
                        onClick={() => setShowInfoFilterModal(true)}>
                        <FontAwesomeIcon 
                            icon={faFilter} 
                            className={
                                chosenInfo.length > 0 
                                ? 'full' 
                                : 'empty'
                            } />
                        {
                            screenSize === 'mobile'
                            ? <FontAwesomeIcon icon={faList} />
                            : 'Info'
                        }
                    </button>
                }
                <button 
                    className={`g-button filter-button ${
                        screenSize === 'mobile' ? 'small-btn' : 'med-btn'
                    }`} 
                    onClick={() => selectAll()}>
                    {
                        screenSize === 'mobile'
                        ? <FontAwesomeIcon icon={faCheckSquare} />
                        : 'Select All'
                    }
                </button>
                <button 
                    className={`g-button filter-button ${
                        screenSize === 'mobile' ? 'small-btn' : 'med-btn'
                    }`} 
                    title='Clear Selected Players' 
                    onClick={() => deselectAll()}>
                    <FontAwesomeIcon 
                        icon={faBan} 
                        size={
                            screenSize !== 'mobile' ? 'lg' : 'sm'
                        } />
                </button>
            </div>
            <div className="g-space-0-5"></div>
            <div className={`g-list-item multiple-select player-selector-box ${screenSize}`}>
                {
                    (playersToDisplay.length > 0) &&
                    playersToDisplay
                    // .sort((a, b) => {
                    //     if ((a.lName && b.lName) && a.lName.toLowerCase() > b.lName.toLowerCase()) {
                    //         return 1;
                    //     } else if ((a.fName && b.lName) && a.fName.toLowerCase() > b.lName.toLowerCase()) {
                    //         return 1;
                    //     } else if ((a.lName && b.fName) && a.lName.toLowerCase() > b.fName.toLowerCase()) {
                    //         return 1;
                    //     } else if ((a.fName && b.fName) && a.fName.toLowerCase() > b.fName.toLowerCase()) {
                    //         return 1;
                    //     } else if ((a.lName && b.lName) && a.lName.toLowerCase() === b.lName.toLowerCase() && a.fName.toLowerCase() > b.fName.toLowerCase()) {
                    //         return 1;
                    //     } else {
                    //         return -1;
                    //     }
                    // })
                    .map(p => (
                        <div 
                            key={p.playerId} 
                            id={p.playerId}
                            className={`multiple-select-option ${
                                chosenPlayers.includes(p.playerId) 
                                ? 'active' 
                                : ''
                            } ${
                                (p.info ? 'has-info' : '')
                            }`}
                            onClick={() => togglePlayer(p)}     
                        >
                            {
                                (type === 'teams')
                                ?
                                <ImageContainer src={p.icon}  />
                                :
                                (p.icon)
                                ?
                                <ImageContainer src={p.icon} />
                                :
                                <div className='gradient' style={{'background': p.gradient}}>{p.fName[0]}</div>
                            }
                            <div>{p.lName ? `${p.lName}, ${p.fName}` : p.fName}</div>
                            {
                                (p.info) &&
                                <div className='meta'>{p.info}</div>
                            }
                        </div>
                    ))
                }
            </div>
            <p className='meta'>{
                Object.values(playerList)
                .filter(p => chosenPlayers.includes(p.playerId)).length
            } {type === 'teams' ? 'Teams' : 'Players'} Chosen</p>
            {
                (!location.pathname.includes('/teams/') && type !== 'teams') &&
                <CategoryFilterModal 
                    show={showFilterModal} 
                    cancel={() => setShowFilterModal(false)} 
                    chooseCategory={chooseTeam} 
                    categoryList={teams} 
                    selectedCategories={chosenTeams} 
                    color='var(--primary)'
                    text='Filter by Team'
                />
            }
            {
                (type !== 'teams') &&
                <CategoryFilterModal 
                    show={showInfoFilterModal} 
                    cancel={() => setShowInfoFilterModal(false)} 
                    chooseCategory={chooseInfo} 
                    categoryList={infoList} 
                    selectedCategories={chosenInfo} 
                    color='var(--primary)'
                    text='Filter by Info'
                />
            }
            <Modal
                show={showQRModal}
                cancel={() => setShowQRModal(false)}
                text="Scan a Player's QR Code"
                closeButton={true}>
                <div className='qr-code-scanner-container'>
                    {
                        (showQRModal) &&
                        <QRCodeScannerV2
                            onScanSuccess={(data) => {
                                setShowQRModal(false);
                                console.log('Scan successful:', data);
                                setSelectedPlayerPath(data);
                                trackEvent(
                                    'player_qrcode_scanned_from_player_selector',
                                    'Game Manager',
                                    `QR code scanned from player selector.`,
                                    null,
                                    membership
                                )
                            }}
                            onScanError={(error) => {
                                console.error('Scan error:', error);
                            }}
                        />
                    }
                </div>
            </Modal>
            <ModalAlert
                show={alertMessage}
                cancel={() => setAlertMessage(null)}
                message={alertMessage}
            />
        </div>
    )
}

export default PlayerSelector